import { Component, OnInit } from '@angular/core';
import { fork } from 'child_process';
import { forkJoin } from 'rxjs';
import { ReportesService } from 'src/app/services/reportes/reportes.service';

@Component({
  selector: 'app-dashboard-admin',
  templateUrl: './dashboard-admin.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardAdminComponent implements OnInit {
  creditos = [];
  creditCols = [
    {field: 'credit_folio', header: 'Folio', moneda: false} ,
    {field: 'customer_name', header: 'Cliente', moneda: false} ,
    {field: 'company_name', header: 'Empresa', moneda: false} ,
    // {field: 'status', header: ''} ,
    {field: 'total_requested', header: 'Total solicitado', moneda: true} ,
    // {field: 'capital', header: ''} ,
    // {field: 'interests', header: ''} ,
    // {field: 'iva', header: ''} ,
    {field: 'total_debt', header: 'Deuda total', moneda: true} ,
    {field: 'plazo', header: 'Plazo', moneda: false} ,
    // {field: 'term_type', header: ''} ,
  ];
  currentPage: number = 1;
  itemsPerPage: number = 8;
  searchTerm: string = '';
  filaSeleccionada: number | null = null;
  colocado = 0;
  pages: (string | number)[];
  isAtBottom: boolean = false;
  contenedor: HTMLElement | null = null;

  constructor(private reportesService: ReportesService) { }

  ngOnInit(): void {
    const scroller = document.querySelector('mat-sidenav-content');

    if (scroller) {
      scroller.addEventListener('scroll', () => {
        this.checkScroll(scroller);
      });
    }
    this.reporteGeneralCredits();
  }

  checkScroll(el: any) {
    const scrollTop = el.scrollTop;
    const viewportHeight = el.clientHeight;
    const height = el.scrollHeight;

    this.isAtBottom = scrollTop + viewportHeight >= height - 50;
  }
  reporteGeneralCredits() {
    this.reportesService.generalCredits().subscribe( resp => {
      this.creditos = JSON.parse(JSON.stringify(resp));
      this.colocado = this.creditos.reduce((sum, credito) => sum + parseFloat(credito.total_requested), 0);
      this.pages = this.generatePages();
    });
  }

  get dataToShow(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.filteredData.slice(startIndex, startIndex + this.itemsPerPage);
  }

  get filteredData(): any[] {

    return this.creditos.filter(item =>
      item.credit_folio.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      item.customer_name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      item.company_name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  seleccionarFila(index: number, currentPage: number, itemsPerPage: number) {
    this.filaSeleccionada = index + (currentPage - 1) * itemsPerPage;
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.pages = this.generatePages();
    }
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.pages = this.generatePages();
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.pages = this.generatePages();
    }
  }

  get totalPages(): number {
    return Math.ceil(this.filteredData.length / this.itemsPerPage);
  }

  /* get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  } */


  pgone() {
    this.currentPage = 1;
    this.filaSeleccionada = -1;
  }

  generatePages(): (number | string)[] {
    const total = this.totalPages;
    const current = this.currentPage;
    const delta = 2; // cantidad de páginas alrededor de la actual
    const pages: (number | string)[] = [];

    // helper para agregar páginas evitando duplicados
    const add = (p: number | string) => {
      if (!pages.includes(p)) pages.push(p);
    };

    add(1);

    // páginas cercanas a la actual
    for (let i = current - delta; i <= current + delta; i++) {
      if (i > 1 && i < total) add(i);
    }

    add(total);

    // insertar ...
    const finalPages: (number | string)[] = [];
    let prev: number | string | null = null;

    pages
      .sort((a, b) => Number(a) - Number(b))
      .forEach((p) => {
        if (prev !== null && Number(p) - Number(prev) > 1) {
          finalPages.push("...");
        }
        finalPages.push(p);
        prev = p;
      });

    return finalPages;
  }

  scrollToBottom() {
    const el = document.querySelector('mat-sidenav-content');
    if (el) el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
  }

  scrollToTop() {
    const el = document.querySelector('mat-sidenav-content');
    if (el) el.scrollTo({ top: 0, behavior: 'smooth' });
  }

}
